import { supabase } from '@/integrations/supabase/client';
import type { User, Session } from '@supabase/supabase-js';

type AuthStateCallback = (event: string, session: Session | null) => void;

export interface AuthSessionPort {
  /** Subscribe to auth state changes. Returns unsubscribe function. */
  onAuthStateChange(callback: AuthStateCallback): () => void;
  /** Get the current session */
  getSession(): Promise<Session | null>;
}

export const supabaseAuthSessionPort: AuthSessionPort = {
  onAuthStateChange(callback: AuthStateCallback) {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => callback(event, session),
    );
    return () => subscription.unsubscribe();
  },

  async getSession() {
    const { data: { session } } = await supabase.auth.getSession();
    return session;
  },
};
